import { useCallback } from 'react'
import { type PurchaseConfirmationModalProps } from '@/features/purchase/components/Modal/PurchaseConfirmationModal'
import { useIsGuestUser } from '@/features/account/services/User/hooks'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { routes } from '@shared/constants/routes'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { DynamicMembershipChangeModal } from '@/features/account/components/Modal/MembershipChangeModals/MembershipChangeModal/DynamicMembershipChangeModal'
import { DynamicMembershipSelectionModal } from '@/features/account/components/Modal/MembershipSelectionModal/DynamicMembershipSelectionModal'
import { DynamicPurchaseConfirmationModal } from '@/features/purchase/components/Modal/PurchaseConfirmationModal/DynamicPurchaseConfirmationModal'
import { usePathWithSearch } from '@/features/shared/hooks/routes/usePathWithSearch'

export const useMembershipModals = () => {
  const isGuestUser = useIsGuestUser()
  const router = useSegwayRouter()
  const { openDialog } = useHandleDialog()
  const pathWithSearch = usePathWithSearch()

  const openMembershipSelectionModal = useCallback(() => {
    if (isGuestUser)
      return router.push(`${routes.SIGN_UP.url}?next=${encodeURIComponent(pathWithSearch)}`)
    openDialog(DynamicMembershipSelectionModal)
  }, [isGuestUser, router, pathWithSearch, openDialog])

  const openMembershipChangeModal = useCallback(
    (isDowngrade = false) => {
      openDialog(DynamicMembershipChangeModal, { isDowngrade })
    },
    [openDialog],
  )

  const openPurchaseConfirmationModal = useCallback(
    (props: PurchaseConfirmationModalProps) => {
      openDialog(DynamicPurchaseConfirmationModal, props)
    },
    [openDialog],
  )

  return {
    openMembershipSelectionModal,
    openMembershipChangeModal,
    openPurchaseConfirmationModal,
  }
}
